export default [
	'afghan.mp3',
	'bands-in-the-culdesac.wav',
	'before-the-storm.mp3',
	'blue-fanta.wav',
	'bubblegum-type.mp3',
	'cellophane.mp3',
	'dap-house.mp3',
	'gelato.mp3',
	'get-it-mane.mp3',
	'goodbye.mp3',
	'high-lights.mp3',
	'holy-grail-777.mp3',
	'killfuckburn.wav',
	'last-night.mp3',
	'liquid-love.mp3',
	'mali.mp3',
	'nacho-libre.mp3',
	'sailboat-destruction.mp3',
	'synthwave.wav',
	'untitled444.wav',
	'worldwide.mp3'
];

// list of beat names for about page